import { Util,Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios4, XtAxios } = Request;

const URL = getOrigin("www") + "/rfapi";

const SAPI_URL = getOrigin("www") + "/sapi/v4";

//推广信息展示
export function get_shareInfo(config) {
  return XtAxios.get(URL + `/public/share/config`, config);
}

//最高比例返佣
export function get_commissionLevel(config) {
  return XtAxios.get(URL + `/public/commission-level/high`, config);
}

/**
 * 从 GET /public/profile/invite/v2/vip-levels 的 result 中，取所有 VIP 档位、所有层级里 cfdCommissionRate 的最大值（0~1 小数）。
 * @param {unknown} apiResult — axios 返回体（含 result 数组）或已是 result 数组
 * @returns {number|null}
 */
export function getMaxCfdCommissionRateFromVipLevelsResponse(apiResult) {
  const list = Array.isArray(apiResult?.result)
    ? apiResult.result
    : Array.isArray(apiResult)
      ? apiResult
      : [];
  let max = -1;
  for (const row of list) {
    const rates = row?.commissionRate;
    if (!Array.isArray(rates)) continue;
    for (const entry of rates) {
      const v = Number(entry?.cfdCommissionRate);
      if (Number.isFinite(v) && v > max) max = v;
    }
  }
  return max >= 0 ? max : null;
}

//用户返佣信息
export function get_profileInfo(config) {
  return XtAxios.get(URL + `/profile/info`, config);
}

// 普通邀请数据总览 v2（时间维度、可选层级、总邀请/佣金汇总）
export function get_inviteOverviewV2(config) {
  return XtAxios.get(URL + `/profile/invite/v2/overview`, config);
}

/** 当前邀请 VIP 等级进度（只看直推有效用户；升级不看开仓保证金） */
export function get_inviteVipProgress(config) {
  return XtAxios.get(URL + `/profile/invite/v2/vip-progress`, {
    ...config,
    isAutoPopError: false,
  });
}

// 邀请 VIP 等级规则列表 v2（未登录也可返回）
export function get_inviteVipLevelsV2(config) {
  return XtAxios.get(URL + `/public/profile/invite/v2/vip-levels`, {
    ...config,
    isAutoPopError: false,
  });
}

/** 邀请 VIP 有效用户配置（未登录公开，Mongo 动态配置） */
export function getInviteVipEffectiveUserConfig(config) {
  return XtAxios.get(URL + `/public/profile/invite/v2/effective-user-config`, {
    ...config,
    isAutoPopError: false,
  });
}

/** Partner 介绍 + FAQ 组合页（未登录公开，Mongo 动态配置） */
export function getInvitePartnerPage(config) {
  return XtAxios.get(URL + `/public/profile/invite/v2/partner-page`, {
    ...config,
    isAutoPopError: false,
  });
}

// 邀请数据总览 v2：总邀请、有效邀请、交易佣金、AI 跟单返佣、邀请奖励、总返佣金额（totalRebateAmountU）
export function get_inviteSummaryV2(config) {
  return XtAxios.get(URL + `/profile/invite/v2/summary`, config);
}

/**
 * 昨日邀请收益弹窗（UTC 昨日；金额 = CFD + AI 跟单 + 有效用户奖励，不含 INVITE 活动奖励）
 * 是否弹窗以 result.needPopup 为准，并需结合本地 dateKey 已读。
 */
export function get_inviteYesterdayRebatePopup(config) {
  return XtAxios.get(URL + `/profile/invite/v2/yesterday-rebate-popup`, {
    ...config,
    isAutoPopError: false,
  });
}

// 邀请数据总览 + 按层级明细 v2
export function get_inviteSummaryByLayerV2(config) {
  return XtAxios.get(URL + `/profile/invite/v2/summary-by-layer`, config);
}

/** 邀请首页轻量总览（Total Rewards / Friends；不含 effectiveInvitations） */
export function get_inviteSummaryLightV2(config) {
  return XtAxios.get(URL + `/profile/invite/v2/summary-light`, {
    ...config,
    isAutoPopError: false,
  });
}

/** 全平台已返佣总金额（公开免登；社会证明大数字） */
export function get_platformRebateTotalPublic(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/public/profile/invite/v2/platform-rebate-total`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, { ...rest, isAutoPopError: false });
}

// AI 跟单邀请成员列表 v2（GET /rfapi/profile/invite/v2/members；page 从 1 开始，传 activityCode + progressFilter）
export function get_inviteAiFollowMembersV2(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/profile/invite/v2/members`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, rest);
}

/** My Team 顶部人数统计（无 timeRange；Valid = is_effective_user） */
export function get_inviteMyTeamV2(config) {
  return XtAxios.get(URL + `/profile/invite/v2/my-team`, {
    ...config,
    isAutoPopError: false,
  });
}

/** 有效用户成员列表 v2（Trading 页；勿用 downline-commission） */
export function get_effectiveUserMembersV2(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/profile/invite/v2/effective-user-members`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, rest);
}

/** 最近返佣动态（公开；跑马灯） */
export function get_recentRebatesPublic(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/public/profile/invite/v2/recent-rebates`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, { ...rest, isAutoPopError: false });
}

// 我的团队 / 成员列表 v2（下级 ID、直属上级、层级、累计返佣；游标分页）
// Query：inviteLayer 精确一层；inviteLayerMin 层级下限（间接名单传 2，且不要同时传 inviteLayer）
// 使用 URLSearchParams 拼 query，避免部分环境下 axios params 未带上 searchKey 等问题
export function get_inviteMembersV2(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/profile/invite/v2/downline-commission`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, rest);
}

// 当前用户返佣流水 v2
// 使用 URLSearchParams 拼 query，保持与 members 接口一致的 query 处理方式
export function get_inviteRebateFlowV2(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/profile/invite/v2/rebate-flow`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, rest);
}

/** 登录在线心跳（TTL 约 5 分钟） */
export function post_profilePresenceHeartbeat(config) {
  return XtAxios.post(URL + `/profile/presence/heartbeat`, null, {
    ...config,
    isAutoPopError: false,
  });
}

/** 批量刷新下级登录在线状态 */
export function get_inviteDownlineOnlineV2(config) {
  const { params, ...rest } = config || {};
  let url = URL + `/profile/invite/v2/downline-online`;
  if (params && typeof params === "object") {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        sp.append(k, String(v));
      }
    });
    const q = sp.toString();
    if (q) url += "?" + q;
  }
  return XtAxios.get(url, { ...rest, isAutoPopError: false });
}

//被邀请人列表
export function get_profileInvitees(config) {
  return XtAxios.get(URL + `/profile/invitees`, config);
}

//被邀请人列表
export function delete_profileInvitee(config) {
  return XtAxios.delete(URL + `/profile/invitee`, config);
}

//邀请码列表
export function get_inviteCodeList(config) {
  return XtAxios.get(URL + `/invite-code/list`, config);
}

//新增推荐
export function post_addInviteCode(config) {
  return XtAxios.post(URL + `/invite-code`, null, config);
}

//推荐默认
export function put_defaultInviteCode(config) {
  return XtAxios.put(URL + `/invite-code/default/${config.data.id}`, null, config);
}

//备注
export function put_remarkInviteCode(id, config) {
  return XtAxios.put(URL + `/invite-code/remark/${id}`, null, config);
}

//数据总览
export function get_commissionData(config) {
  return XtAxios.get(URL + `/commission-data/summary`, config);
}

//被邀请人交易量及当日数据总览
export function get_tradeDaySummary(config) {
  return XtAxios.get(URL + `/commission-data/trade-day-summary`, config);
}

//被邀请人列表
export function get_commissionInvitees(config) {
  return XtAxios.get(URL + `/commission-data/invitees`, config);
}

//推荐人返佣
export function get_commissionList(config) {
  return XtAxios.get(URL + `/commission-data/commission-list`, config);
}

//被推荐人返现
export function get_commissionBackList(config) {
  return XtAxios.get(URL + `/commission-data/commission-back-list`, config);
}

//推荐人返佣 -- 导出
export function get_commissionListExport(config) {
  return XtAxios.get(URL + `/commission-data/commission-list-export`, config);
}

//被推荐人返现 -- 导出
export function get_commissionBackListExport(config) {
  return XtAxios.get(URL + `/commission-data/commission-back-list-export`, config);
}

// 邀请活动规则：
// 登录：GET /sapi/v4/activity/invite-rules/{activity}
// 未登录：GET /sapi/v4/public/activity/invite-rules/{activity}
export function getReferralRule(config) {
  const { activity, isPublic = false, ...rest } = config || {};
  const path = `${SAPI_URL}${isPublic ? "/public" : ""}/activity/invite-rules/${encodeURIComponent(activity ?? "")}`;
  return XtAxios.get(path, rest);
}
